import { useSelector } from "react-redux";
import { getLoanId, getNhDealApplicationId } from "features/authSlice";
import { useGetLoanSummaryDetailQuery } from "pages/dashboard/home/dashboardService";

export const useLoanSummaryData = (persistState = false) => {
  const nhDealApplicationId = useSelector(getNhDealApplicationId);
  const loanId = useSelector(getLoanId);

  const { data: loanSummary } = useGetLoanSummaryDetailQuery({ nhDealApplicationId, loanId, persistState });

  const hasLoanSummaryData = (): boolean => {
    if (!loanSummary) return false;

    const { propertyLocation, loanPurpose, loanAmount, loanNumber } = loanSummary;

    const hasValidPropertyLocation = propertyLocation && (
      (propertyLocation.addressLine1 && propertyLocation.addressLine1.trim() !== '') ||
      (propertyLocation.addressLine2 && propertyLocation.addressLine2.trim() !== '') ||
      (propertyLocation.cityName && propertyLocation.cityName.trim() !== '') ||
      (propertyLocation.stateCode && propertyLocation.stateCode.trim() !== '') ||
      (propertyLocation.postalCode && propertyLocation.postalCode.trim() !== '')
    );

    const hasValidLoanPurpose = loanPurpose && loanPurpose.trim() !== '';
    const hasValidLoanAmount = loanAmount !== null && loanAmount !== undefined;
    const hasValidLoanNumber = loanNumber && loanNumber.trim() !== '';

    return Boolean(
      hasValidPropertyLocation &&
      hasValidLoanPurpose &&
      hasValidLoanAmount &&
      hasValidLoanNumber
    );  
  };

  return {
    hasLoanSummaryData: hasLoanSummaryData(),
    loanSummary
  };
};